import { render, staticRenderFns } from "./FacetFields.vue?vue&type=template&id=a3bf6978&scoped=true&"
import script from "./FacetFields.vue?vue&type=script&lang=js&"
export * from "./FacetFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf6978",
  null
  
)

export default component.exports